import { find, get } from 'lodash';
import requirementsSelector from '../../AppointmentRequirementsSelector';
import { AgeWarningConfirmationView } from './AgeWarningConfirmationView';
import {
    clickCheckbox,
    trackClickAgeWarning,
} from './AgeWarningConfirmationActions';
import { connect } from 'react-redux';
import {
    AGE_WARNING_CONFIRMATION_STATE_KEY,
    AGE_WARNING,
} from '../../constants';

export function mapStateToProps(state, ownProps) {
    const requirements = requirementsSelector(state);
    const ageRequirement = find(
        ownProps.requirements,
        req => req.key === AGE_WARNING
    );

    return {
        isChecked: requirements[AGE_WARNING_CONFIRMATION_STATE_KEY].value,
        invalidMessage: requirements[AGE_WARNING_CONFIRMATION_STATE_KEY].error,
        ageRequirementText: get(ageRequirement, 'suggested_message', ''),
    };
}

export const mapDispatchToProps = {
    onCheck: clickCheckbox,
    trackClickAgeWarning,
};

export const AgeWarningConfirmationConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(AgeWarningConfirmationView);
